import axios from 'axios';
import {typesNonProd} from '../svtypes/nonProd'
import { SV_SOJ_ORCMOCK_ADDRESS, SV_SOJ_SVDJMOCK_ADDRESS } from '../../constants';
const _ = require('lodash')

function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }

  /*sv sept7 start */

export function sojAndImagesSV(sojPostRqFromPage, sv_esquery_data){
    console.log('sv**OCT16 esqueryText*********', sv_esquery_data)
                       
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaCanQueryFinal`
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            if(_.isString(sojPostRqFromPage) ){
               console.log('STATS')
            }else{
                sojPostRq = sojPostRqFromPage
            }
            
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers, validateStatus: false}),
            axios.get(urlSojImages, {headers:headers, validateStatus: false})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                let r = {data:{}}
                r.data = rFob.svo
                let p = {data:{}}
                p.data  = rFob.dbo
                let prices = []
                let prices_idx = []
                let a_price = null;
                let prices_map = {}
               
                if(p.data.hits.hits.length>0){
                    prices_idx = p.data.hits.hits
                }
                prices_idx.forEach(p_rec => {
                    let p_item = {}
                    let p_lc = {}
                    p_item = p_rec['_source']
                    p_lc =lowercaseKeys(p_item)
                    prices.push(p_lc)
                   
                });
                prices.forEach(p => {
                    let k =p.spacekey
                    prices_map[k] = p
                });
                console.log('sv**SPET9 MONDAY **************** Prices_map START')
                console.log(prices_map)
                console.log('sv**SPET9 MONDAY **************** Prices_map END')
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    if( r2.data && r2.data.images[0]){
                        comData.my_images = r2.data.images[0]
                    }
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                    ob['sv_rating'] = sv_rating
                    ob['sv_availability_of_rooms'] = 8
                    let k_sv = ob['spacekey']
                    a_price = prices_map[k_sv]
                    if(a_price){

                        ob = _.merge(ob, a_price)
                    }
                         
                       /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
                       
    
                        comData.my_data.push(ob)
                        console.log('sv**OCT16 esqueryText partof sv_esquery_data*********', sv_esquery_data)
                        comData.sv_esquery_data =  sv_esquery_data  
                    });
                   
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.sv_esquery_data = {
                        my_esqueryText: "mexco",
                        STARTDATE:"2023-10-24",
                        ENDDATE: "2023-11-27" , 
                        time_zone: "+01:00"
                
                      }
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}

  /*sept7 end */

export function sojAndImagesSV_old(sojPostRqFromPage){
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaCanQuery`
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}

/**facet lsiteview */
export function sojAndImagesSVFacet_old(sojPostRqFromPage){
    return dispatch => {
        dispatch(getEsSearchBegin())
       //svuilaFacetView
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaFacetViewCanQuery`
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}
const headers = {'Content-Type': 'application/json'}
export function sojAndImagesSV_Workigng_latest(sojPostRqFromPage){
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/svsearchElastic`
        let sojPostRq = {
            "query": {
                "multi_match": {
                    "fields": [
                        "SOJOURN_NAME", "EN_REGION_HIERARCHY"
                    ],
                    "query": "WorldMark ",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            }
        }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
           /*
           sojPostRq = {
            "query": {
              "match_all": {}
            }
          }*/
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    ar.forEach(a_rec => {
                        item = {}
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)
                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}


export function sojAndImagesSV_uses_es_lowercaseKeys_working(sojPostRqFromPage){
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        let sojPostRq = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob
                    ar.forEach(a_rec => {
                        item = {}
                        ob = a_rec['_source']
                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}

/*end.....*/
/*  
export function sojAndImagesOls(nameQParam){
   
    const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
    const sojPostRq = {
        "query": {
          "match": {
            "sojourn_name": {
              "query": "mancreek",
              "operator": "and"
            }
          }
        }
      }
   

    const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
    axios.all([
        axios.post(urlSoj, sojPostRq, {headers:headers}),
        axios.get(urlSojImages, {headers:headers})
    ])
    .then(
        axios.spread((r,r2)=>{
            if(r.data.hits.hits.length>0){
                const ar = r.data.hits.hits
                const comData = { my_data: []}
                let item , ob
                ar.forEach(a_rec => {
                    item = {}
                    ob = a_rec['_source']
                    let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                    let sv_rating = 'Excellent'
                   if(rating == 0){
                    sv_rating = 'Excellent'

                   }else if(rating == 1){

                    sv_rating = 'Poor'
                }else if(rating == 2){
                    sv_rating = 'Fair'
                }else if(rating == 3){

                    sv_rating = 'Recommend'
                }else if(rating == 4){
                    sv_rating = 'Favorite'
                }else if(rating == 5){
                    sv_rating = 'Excellent'
                }else {

                    sv_rating = 'Excellent'
                   }
                   ob['sv_rating'] = sv_rating
                   ob['sv_availability_of_rooms'] = 8
                    


                    comData.my_data.push(ob)
                });
                if( r2.data && r2.data[0]){
                    comData.my_images = r2.data[0]
                }
               
                dispatch(getEsSearchMultiplceCallsSuccess(comData))
            }
            else {
                const comData = { items: []}
                dispatch(getEsSearchSuccess(comData))
            }
              
               
            }
        )
    ).catch(
        e => {dispatch(getIncidentsError(e.message))}
    )
}
*/
export function getSoDetails(nameQParam){
    return dispatch => {
        dispatch(getEsSearchBegin())
       
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        const body = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }
          
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob
                    ar.forEach(a_rec => {
                        item = {}
                        ob = a_rec['_source']
                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'

                       }else if(rating == 1){

                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){

                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {

                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */


                        comData.my_data.push(ob)
                    });

                   
                    dispatch(getEsSearchSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getEsSearchSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getEsSearchError(e))
        )
    }
}


export const getEsSearchSuccess = (data) => dispatch => {
    dispatch({
        type: typesNonProd.GET_NON_PROD_SUCCESS,
        payload: data
    })
}

export const getEsSearchMultiplceCallsSuccess = (data) => dispatch => {
    dispatch({
        type: typesNonProd.GET_NON_PROD_SUCCESS,
        payload: data
    })
}

export const getEsSearchBegin = () => dispatch => {
    dispatch({
        type:typesNonProd.GET_NON_PROD_BEGIN
        
    })
}

export const getEsSearchError = (e) =>dispatch => {
    dispatch({
        type:typesNonProd.GET_NON_PROD_ERROR,
        error:e
    })
}



const getDinoRecords = () => {
    const headers = {'content-type': 'application/json'};
    let url = "http://localhost:8080/svapi/coreend/control";
    let ob = {'content-type': 'application/json'};
    return axios.get(url, {headers: ob})
}

export const loadDinoAction = async (dispatch) => {
    const response = await getDinoRecords();
    console.log(response);
    if (response) {
        let payload = {
            my_data: response.data
        }
        return dispatch({
            type: "dino-success",
            payload: payload
        });
    } else {
        console.log("Server error");
    }
}

export const loadRadioAction =  (dispatch, radio_data) => {
    console.log('dinoActions recvd radio)data');
     console.log(radio_data) ;
     return dispatch({
        type: "radio-success",
        payload: radio_data
    });
}


export function sojAndImagesSVFacet(sojPostRqFromPage, sv_esquery_data){
    console.log("svoct17 sojAndImagesSVFacet ******sv_esquery_data", sv_esquery_data)
    return dispatch => {
        dispatch(getEsSearchBegin())
       //svuilaFacetView
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaFacetViewCanQuery`
        const urlSoj = `${SV_SOJ_SVDJMOCK_ADDRESS}/trip/absvfacetab/`
       

          let sojPostRq = {
            "dates": {
                "STARTDATE_ITN_TZAWARE_EST": "2025-11-25",
                "ENDDATE_ITN_TZAWARE_EST": "2025-11-27",
                "DT_FORMAT": "%Y-%m-%d",
                "time_zone": "+01:00",
                "OP": "range"
            },
            "facets": {
               "EN_AMENITY_NAME_LVL.keyword": ["Health Club", "WiFi Available"]
            },
            "loc": "mexico"
    
        }
       
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((r,r2)=>{
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob, upperOb
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                    console.log('sv**OCT16 esqueryText partof sv_esquery_data*********', sv_esquery_data)
                    comData.sv_esquery_data =  sv_esquery_data  
                   
                    dispatch(getEsSearchMultiplceCallsSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    comData.sv_esquery_data = {
                        my_esqueryText: "mexco",
                        STARTDATE:"2023-10-24",
                        ENDDATE: "2023-11-27" , 
                        time_zone: "+01:00"
                
                      }
                    dispatch(getEsSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getEsSearchError(e))}
           
        )
    }
}

